import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-add-group',
    templateUrl: './add-group.component.html',
    styleUrls: ['./add-group.component.scss'],
})
export class AddGroupComponent implements OnInit {

    @Input()
    public userListBase: any;

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private translate: TranslateService) {
        }

    ngOnInit() {
    }

    public async validate(data) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        data.id = 0;
        data.data.id = 0;
        data.data.autogenerated = false;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setgroupdata', data));
            this.onValidate.emit({ data: wRes });
        } catch (error) {
            if (error.error.Message === 'Exist') {
                this._messageService.addWarn(this.translate.instant('Cf_GroupExist', {group: data.data.grpname}));
            } else {
                this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            }
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
